/**
 * @file Election/constants.js
 * @copyright 2018 CBC/Radio-Canada. All rights reserved.
 */

export const REFRESH_TIME = 20 * 1000; // in milliseconds
